import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useSearchResultCardContext } from './SearchResultCardProvider';
import ArrowThinRightIcon from '../../assets/icons/small/Arrow-2-Right.svg';

import contentStyles from './SearchResultCardContent.module.css';
import articleStyles from './SearchResultCardArticleWrapper.module.css';

export const SearchResultCardRequestAccessLabel = () => {
  const { translationResolver: t } = useSearchResultCardContext();

  return (
    <div className={contentStyles.restrictedRequestAccessContainer}>
      <Copy size="l" text={t('search.results.listingCard.privateOffice.requestAccess')} />
      <ArrowThinRightIcon className={articleStyles.arrowRightIcon} />
    </div>
  );
};
